import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FileInterface, IdInterface } from '../data';
import { TransferProvider } from '../providers/transfer-provider.service';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetValidModelPDFUseCaseParams {
    id: IdInterface;
}

@Injectable()
export class GetModelPdfUseCase implements UseCaseWithParam<GetValidModelPDFUseCaseParams, Observable<Transaction<FileInterface>>> {
    constructor(private transferProvider: TransferProvider) {}

    bind(params: GetValidModelPDFUseCaseParams): Observable<Transaction<FileInterface>> {
        return this.transferProvider.getModelPdf(params.id);
    }
}
